import React from 'react';
// import PropTypes from 'prop-types';

const CircleProgressBar = ({ percent, message, stroke = 10, type, className, bgStrokeColor = "#E6E6E6", barStrokeColor = "#4CAF50" }) => {
  const radius = type === "employee" ? 25 : 50; // Radius of the circle
  // const stroke = 6; // Stroke width
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percent / 100) * circumference;

  return (
    <div className={`circle-progress-container ${className || ''} ${type === "employee" ? 'w-60px h-60px' : ''}`}>
      {type === "employee" ? (
        <svg width="60" height="60" className="circle-progress-svg border rounded-5">
          <circle
            className="circle-progress-background bg-light-blue"
            style={{ fill: "#ECF3FF", stroke: "#fff"}}
            cx="30"
            cy="30"
            r={radius}
            strokeWidth={"5"}
          />
          <circle
            className="circle-progress-bar"
            style={{ fill: "#ECF3FF", stroke: "#3D7EFF"}}
            cx="30"
            cy="30"
            r={radius}
            strokeWidth={"5"}
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
          />
          <text
            x="52%"
            y="56%"
            textAnchor="middle"
            alignmentBaseline="middle"
            className="circle-progress-text"
          >
            <tspan className="circle-progress-percent fs-15">{percent}%</tspan>
            <tspan className="circle-progress-message" x="50%" dy="1.2em">
              {message}
            </tspan>
          </text>
        </svg>
      ) : (
        <svg width="120" height="120" className="circle-progress-svg">
        <circle
          className="circle-progress-background"
          cx="60"
          cy="60"
          r={radius}
          strokeWidth={stroke}
          stroke={bgStrokeColor}
        />
        <circle
          className="circle-progress-bar"
          cx="60"
          cy="60"
          r={radius}
          strokeWidth={stroke}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          stroke={barStrokeColor}
        />
        <text
          x="52%"
          y="56%"
          textAnchor="middle"
          alignmentBaseline="middle"
          className="circle-progress-text"
        >
          <tspan className="circle-progress-percent">{percent}%</tspan>
          <tspan className="circle-progress-message" x="50%" dy="1.2em">
            {message}
          </tspan>
        </text>
      </svg>
      )}
    </div>
  );
};

// Prop types validation
// CircleProgressBar.propTypes = {
//   percent: PropTypes.number.isRequired,
//   message: PropTypes.string.isRequired,
// };

export default CircleProgressBar;
